/**
 * defaultTiendaConfig.ts — Configuración demo por defecto de la Tienda Virtual.
 * Fuente única para MSW, bootstrap demo y fallbacks del servicio.
 */
import type { TiendaConfig } from "../types/tienda.types";
import {
  getAsistenteDefaults,
  getSobreNosotrosDefaults,
} from "./tiendaAsistentePresets";

export const DEFAULT_TIENDA_CONFIG: TiendaConfig = {
  businessId: "business_1",
  businessSlug: "altenot-store",
  businessName: "Altenot Store",
  descripcion:
    "Sistema de control total para tu negocio — caja, inventario, personal, auditoría y métricas con IA. Desde $89.900/mes. Fácil como WhatsApp, poderoso como un ERP.",
  colorPrimario: "#2563eb",
  colorFooter: "#0f172a",
  headerStyle: "bubbles",
  headerIcon: "Store",
  tarjetaLayout: "uniforme",
  mostrarDescripcionTarjeta: false,
  logoUrl: "",
  bannerUrl: "",
  metodoPagoHabilitados: ["efectivo", "nequi", "daviplata", "transferencia"],
  whatsappPedidos: true,
  pedidosEnApp: true,
  monedaSimbolo: "$",
  telefono: "310 000 0000",
  direccion: "Cra. 15 #45-20, Bogotá",
  horario: "Lun–Sáb 8am–8pm",
  redesSociales: {
    whatsapp: "573100000000",
    instagram: "mitienda_ig",
    facebook: "MiTiendaFbOficial",
  },
  horarioOperativo: {
    tiendaAbierta: true,
    diasOperacion: [1, 2, 3, 4, 5, 6],
    horaApertura: "07:00",
    horaCierre: "22:00",
    accionAlCerrar: "vitrina",
    cierreMotivo: "colapso",
  },
  politicasEnvio:
    "Confirmo que la dirección, los datos de contacto y el horario de entrega son correctos.",
  mensajeFinalPedido:
    "Gracias, {nombre}. Recibimos tu pedido #{numero} por {total}.",
  instruccionesPago: {
    efectivo:
      "Ten el valor exacto o cercano al total al momento de recibir tu pedido.",
    transferencia:
      "Realiza la transferencia y conserva el comprobante para validarlo al confirmar el pedido.",
  },
  mostrarProgramaPuntos: true,
  mostrarPortalEmpleo: false,
  mostrarEscanerProductos: true,
  bannerPromocional: {
    activo: false,
    texto: "",
    color: "#059669",
    enlace: "",
  },
  envioConfig: {
    cobrarEnvio: false,
    costoEnvio: 0,
    envioGratisDesde: null,
    compraMinimaActiva: false,
    compraMinimaMonto: 0,
    compraMinimaSoloDomicilio: true,
  },
  asistenteConfig: getAsistenteDefaults(),
  sobreNosotros: getSobreNosotrosDefaults(),
};
